import script from "./Slider.vue?vue&type=script&setup=true&lang=js"
export * from "./Slider.vue?vue&type=script&setup=true&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=73330da2&lang=scss"

const __exports__ = script;

export default __exports__